<template>
  <div  >
    <Header
        :leftArrow="true"
        :leftText="''"
        @leftClick="onClickLeft"
        @onRefreshClick="onRefresh"
        :rightIcons="true"
    >
    </Header>
    <audio class="rounded centered" id="roomaudio" width="100%" height="100%" autoplay/>
    <div class="home income">
      <div class="income_wrap">
        <div class="income_room-name">
          <p class="room-detail_title">チーム名</p>
          <div class="room-name_box">
            <input type="text" class="room-name" :value="team_name" readonly>
          </div>
        </div>

        <div class="income_room_team-member">
          <p class="title-team-name income_room_title">チームメンバー</p>
          <div class="team-block">
            <div class="user-item" v-for="item in doctorList" :key="item">
              <p class="user-name" v-show="item.online_status =='online'">
                <span :class="item.online_status =='online' ? 'online':'offline'">オンライン</span> {{item.name}}
              </p>
              <p class="user-name" v-show="item.online_status !=='online'">
                <span :class="item.online_status =='online' ? 'online':'offline'">オフライン</span> {{item.name}}
              </p>
              <span v-show="userInfo.login_account_id == item.doctor_id" class="user-staff">(自身)</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import Header from "@/components/Header.vue";
import {Toast} from "vant";
import "vant/es/toast/style";
import { GetTeamDetail} from "@/services/team";

export default {
  data() {
    return {
      active: 0,
      doctorList:[],
      userInfo: {},
      team_id:"",
      team_name:"",
    };
  },
  components: {
    Header
  },
  mounted() {
    this.userInfo = JSON.parse(localStorage.getItem(process.env.VUE_APP_USER_KEY));
    this.team_id = this.$route.query.team_id;
    this.team_name = this.$route.query.team_name;
    this.$emit("changeReceiveRecordTeam",{page:"audioBridge",receiveRecordTeam:this.team_id});
    this.initDoctorList();
  },
  beforeRouteLeave(to, from, next) {
    this.$emit("changeReceiveRecordTeam",{page:"",receiveRecordTeam:""});
    next();
  },
  methods: {
    async initDoctorList() {
      let res = await GetTeamDetail(this.team_id);
      if (res.data.data.doctors) {
        this.doctorList = res.data.data.doctors;
      } else {
        this.doctorList = [];
      }
    },
    onClickLeft() {
      history.back();
    },
    onRefresh() {
      Toast.loading({
        message: "",
        forbidClick: true,
        duration: 1000,
      });
    },
  },
  computed: {
  },
  watch: {},
};
</script>

<style scoped>
   
</style>
